import React from 'react';
import { Navigate } from 'react-router-dom';
import { LoginForm } from '@/features/auth';
import { useAuth } from '@/features/auth';
import PageMeta from '@/shared/components/PageMeta';

export const Login: React.FC = () => {
    return (
        <>
            <PageMeta title="Login" description="Login to your MotorPlan dashboard" />
            <LoginForm />
        </>
    );
};

export const Logout: React.FC = () => {
    const { logout } = useAuth();

    // Perform logout and redirect to login page
    React.useEffect(() => {
        logout();
    }, [logout]);

    return <Navigate to="/login" replace />;
};
